import { useState, useEffect, useCallback } from 'react';
import { getInvitations, resendInvitation, removeInvitation } from '../services/InvitationService';
import { getUsers } from '../services/UserService';

const STATUS_TRANSLATIONS = [
  'sent',
  // PlatformAPI saves invitations as "pending" when it couldn't send them
  'pending',
  // not found "failed" invitations on metabase, what is this status for?
  'failed',
];

export function useUsersAndInvitations() {
  const [invitations, setInvitations] = useState(null);
  const [users, setUsers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  // Usamos useCallback para que la función sea estable y se pueda pasar/reusar de forma segura
  const fetchData = useCallback(async () => {
    try {
      setApiError(null);
      const [invs, usrs] = await Promise.all([getInvitations(), getUsers()]);
      const notAcceptedInvitations = invs.filter((i) => STATUS_TRANSLATIONS.includes(i.status));
      setInvitations(notAcceptedInvitations);
      setUsers(usrs);
    } catch (error) {
      setApiError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Carga inicial
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleResend = async (invitation) => {
    try {
      setApiError(null);
      await resendInvitation(invitation.id);
      setSuccessMessage(`La invitación a ${invitation.email} ha sido reenviada.`);
    } catch (error) {
      setApiError(error);
    }
  };

  const handleRemove = async (invitation) => {
    try {
      setApiError(null);
      await removeInvitation(invitation.id);
      setSuccessMessage(`Se eliminó la invitación a ${invitation.email}`);
      await fetchData(); // Re-fetch para sincronizar el estado
    } catch (error) {
      setApiError(error);
    }
  };

  const handleDeleteUserSuccess = async () => {
    setSuccessMessage('Se eliminó el usuario correctamente');
    await fetchData();
  };

  const handleInviteSuccess = (email, isEditing) => {
    setSuccessMessage(
      isEditing
        ? `Los cambios para ${email} se han guardado.`
        : `La invitación a ${email} ha sido enviada.`,
    );
    fetchData();
  };

  return {
    invitations,
    users,
    loading,
    apiError,
    successMessage,
    setSuccessMessage,
    setApiError,
    handleResend,
    handleRemove,
    handleDeleteUserSuccess,
    handleInviteSuccess,
  };
}
